import { EchartsWithTheme, Empty, useTheme } from '@maxtropy/components';
import { EchartsWithThemeRef } from '@maxtropy/components/es/components/EchartsWithTheme';
import React, { FC, useMemo, useRef, useState } from 'react';
import styles from './index.module.scss';
import { getChartOption } from './chart';
import { DateType, RankMethod, RankMethodType } from '@/pages/EnergyAnalysisRanking/utils';
import { V2EnergyUnitConsumptionRankingPostResponse } from '@maxtropy/device-customer-apis-v2';
import ShowDetailModal from '../RankTable/ShowDetailModal';
import dayjs from 'dayjs';
import { CustomerRequest } from '../..';

export interface IChart {
  data?: V2EnergyUnitConsumptionRankingPostResponse['list'];
  loading?: boolean;
  customerRequest?: CustomerRequest;
  timeResolution?: DateType;
  rankMethod: RankMethod;
  energyMethod?: RankMethodType;
  selectedConsumption?: number;
  energyUnitGroupId?: number;
  displayValue?: dayjs.Dayjs;
  dataQueryPeriodId?: number;
  dataQueryPeriodName?: string;
}

const Chart: FC<IChart> = props => {
  const {
    data,
    loading,
    rankMethod,
    customerRequest,
    timeResolution,
    energyMethod,
    selectedConsumption,
    energyUnitGroupId,
    displayValue,
    dataQueryPeriodId,
    dataQueryPeriodName,
  } = props;
  const theme = useTheme();
  const chartRef = useRef<EchartsWithThemeRef>();
  const [openModal, setOpenModal] = useState(false); // 新建配置弹窗
  const [recordId, setRecordId] = useState<number>(); // 每行数据的id

  // 图表
  const chartOption = useMemo(
    () =>
      getChartOption({
        rankMethod,
        timeResolution,
        energyMethod,
        selectedConsumption,
        data,
        dataQueryPeriodName,
        customerRequest,
      }),
    [energyMethod, selectedConsumption, data, rankMethod]
  );
  return (
    <>
      <EchartsWithTheme
        theme={theme}
        loading={loading}
        empty={{
          isShowEmpty: data?.length === 0,
          emptyNode: <Empty className={styles.empty_box} />,
        }}
        ref={d => {
          if (d) {
            chartRef.current = d;
          }
        }}
        onEvents={{
          click: (params: any) => {
            if (params?.data?.id) {
              setRecordId(params?.data?.id);
              setOpenModal(true);
            }
          },
        }}
        style={{ height: 650, width: '100%' }}
        option={chartOption}
      />
      {openModal && (
        <ShowDetailModal
          timeResolution={timeResolution}
          displayValue={displayValue}
          id={recordId}
          customerRequest={customerRequest}
          selectedConsumption={selectedConsumption}
          energyUnitGroupId={energyUnitGroupId}
          dataQueryPeriodId={dataQueryPeriodId}
          dataQueryPeriodName={dataQueryPeriodName}
          onCancel={() => {
            setOpenModal(false);
            setRecordId(undefined);
          }}
        />
      )}
    </>
  );
};

export default Chart;
